var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './TreeSelect.module.scss';
import { ArrowDown } from '../../assets/icons';
import { ANIMATE_HEIGHT } from '../../constants';
import { Chips } from '../Chips/Chips';
import { ClickDetector } from '../ClickDetector/ClickDetector';
import { TreeSelectOptions } from '../TreeSelectOptions/TreeSelectOptions';
var TreeSelect = function (_a) {
    var selected = _a.selected, label = _a.label, placeholder = _a.placeholder, disabled = _a.disabled, required = _a.required, preview = _a.preview, error = _a.error, errorMessage = _a.errorMessage, options = _a.options, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState([]), opened = _c[0], setOpened = _c[1];
    var classes = "".concat(isOpen ? styles.Active : '', " ").concat(disabled ? styles.Disabled : '', " ").concat(error ? styles.Error : '');
    var renderOptions = useMemo(function () { return (_jsx("section", __assign({ className: styles.OptionWrapper }, { children: _jsx(TreeSelectOptions, { options: options, selected: selected, opened: opened, disabled: preview, onChange: onChange, onOpenedChange: setOpened }) }))); }, [options, selected, opened]);
    return (_jsxs("div", __assign({ id: id, className: "".concat(styles.TreeSelectContainer, " ").concat(className ? className : '') }, { children: [_jsxs("label", __assign({ className: styles.Label }, { children: [label, required && _jsx("span", __assign({ className: styles.Required }, { children: "*" }))] })), _jsx(ClickDetector, __assign({ onOutsideClick: function () { return setIsOpen(false); }, dataId: 'detector' }, { children: _jsxs("div", __assign({ className: styles.TreeSelectWrapper, onClick: function () { return !disabled && !isOpen && setIsOpen(true); }, "data-testid": dataId }, { children: [_jsxs("div", __assign({ className: "".concat(styles.TreeSelect, " ").concat(classes) }, { children: [!!selected.length && (_jsx(Chips, { options: selected, onChange: onChange, removeable: !disabled && !preview, primary: true, limit: 1 })), !selected.length && placeholder && _jsx("span", __assign({ className: styles.Placeholder }, { children: placeholder })), _jsx("i", __assign({ className: styles.Icon }, { children: _jsx(ArrowDown, {}) }))] })), !isOpen && error && errorMessage && (_jsx("span", __assign({ className: "".concat(styles.ErrorMessage, " ").concat(ANIMATE_HEIGHT) }, { children: errorMessage }))), isOpen && (_jsx("div", __assign({ className: styles.OptionContainer, "data-testid": 'options' }, { children: renderOptions })))] })) }))] })));
};
TreeSelect.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.any).isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    preview: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
TreeSelect.defaultProps = {
    selected: [],
};
export { TreeSelect };
//# sourceMappingURL=TreeSelect.js.map